import { render, staticRenderFns } from "./basic.vue?vue&type=template&id=5ac22162&scoped=true"
import script from "./basic.vue?vue&type=script&lang=js"
export * from "./basic.vue?vue&type=script&lang=js"
import style0 from "./basic.vue?vue&type=style&index=0&id=5ac22162&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac22162",
  null
  
)

export default component.exports